<template>
  <div>    
    <center> 
        <b-row class="justify-content-center mt-2"> 
                <b-col cols="11" md="3" v-if="isMobile">
                <v-btn :color="tab == 0 ? '#1975B8' : '#29486F'" class="mt-2"  size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaTab(0)"> 
                    IDPDV
                </v-btn>
                </b-col> 
                <b-col cols="11" md="3" v-if="isMobile">
                    <v-btn :color="tab == 3 ? '#1975B8' : '#29486F'" class="mt-2"  size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaTab(3)"> 
                        Ejecutivo
                    </v-btn>
                </b-col> 
                <b-col cols="11" md="3" v-if="user.perfil == 'Coordinador' && isMobile">
                <v-btn :color="tab == 2 ? '#1975B8' : '#29486F'" class="mt-2"  size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaTab(2)"> 
                    Coordinador
                </v-btn>
                </b-col>
        </b-row>
    </center> 
    <hr style="margin-top:25px;"> 
    <b-row class="justify-content-center">
        <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'Todas' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('Todas')"> 
                Regiones
            </v-btn>
        </b-col>
        <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'CENTRO FORANEO' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('CENTRO FORANEO')"> 
                Centro Foráneo
            </v-btn>
        </b-col>
        <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'CENTRO METROPOLITANO' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('CENTRO METROPOLITANO')"> 
                Centro Metropolitano
            </v-btn>
        </b-col>
        <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'NORTE' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('NORTE')"> 
                Norte
            </v-btn>
        </b-col>
        <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'OCCIDENTE' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('OCCIDENTE')"> 
                Occidente
            </v-btn>
        </b-col>
         <b-col cols="11" md="7" lg="10" xl="10" class="mt-2">   
            <v-btn :color="region_pdv == 'SUR' ? '#1975B8' : '#29486F'"   size="small" block  dark style="text-transform:capitalize; border-radius: 10px;"  @click="cambiaRegion('SUR')"> 
                Sur
            </v-btn>
        </b-col> 
        <b-col cols="11" md="7" lg="3" xl="3" class="mt-2"> 
            <input v-model="buscar_gerente" type="text" class="form-control mt-4" placeholder="Buscar"  v-if="tab == 0"  style="border-radius: 10px;  height: 75%;" >
            <input v-model="buscador_ejecutivo" type="text" class="form-control mt-4" placeholder="Buscar"  v-if="tab == 3"  style="border-radius: 10px;  height: 75%;" >
            <input v-model="buscar_coordinador" type="text" class="form-control mt-4" placeholder="Buscar" v-if="tab == 2 && user.perfil == 'Coordinador'"  style="border-radius: 10px;  height: 75%;">
        </b-col>
    </b-row>  
     <b-row class="justify-content-center mt-2">
        <b-col cols="11" md="11" lg="11" xl="11" class="text-center mt-1">
            <!-- <br> <br v-if="!isMobile"> -->
            <center v-if="loader">
                <SpinnerLoader/>
                <p style="color:#000;">Procesando información, no cierres el navegador <br> espera un momento...</p>
            </center>  
            <template v-if="tab == 0">   

                 <div class="table-responsive" id="global">
                    <b-row class="justify-content-center mt-2">
                      <b-col cols="11" md="6" class="mt-2"> 
                        <div v-for="(ran, index) in gerente" :key="ran.id">
                            <b-card  text-variant="white" class="text-center mt-5 shadow"  header-tag="header"  >
                                <template #header>
                                    <h4 class="mb-0" style="font-size:25px;"> <b>{{ran.idpdv}}</b> <br> <span style="font-size:15px;">{{ran.tienda}} </span> </h4>
                                </template>
                                <b-card-text >
                                    <b-row class="justify-content-center" style="margin-top:-90px;">
                                        <b-col cols="10"  style="margin-top:-5px;"> 
                                                <br > <br > <br><br v-if="isMobile">  
                                            <template v-if="!buscar_gerente">
                                                <img v-if="index < 10" :src="'plato/'+ index + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h5 v-if="index > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                    <b>{{index + 1  }}</b>
                                                </h5>  
                                            </template>
                                            <template v-else>
                                                <img v-if="ran.lugar < 10" :src="'plato/'+ (ran.lugar - 1)  + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h4 v-if="ran.lugar > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                <b> {{ran.lugar}}</b>
                                                </h4>  
                                            </template>
                                            <br > 
                                            <h1 style="color: #0c273a; font-size:25px;"><b>Puntos: {{ran.total}}</b> </h1>
                                        </b-col>
                                    </b-row>
                                    <b-row class="justify-content-center" style="margin-top:20px;"> 
                                        <b-col cols="11">
                                            <b  style="color: #0c273a; font-size:20px;">Cumplimientos</b>
                                            <b-row  class="justify-content-center mt-2">
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Marzo</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;" class="mt-2" >
                                                            {{ran.marzo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Abril</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.abril}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Mayo</b></span>  
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.mayo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;  margin-left: -10px;"><b>Junio</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.junio}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                            </b-row>
                                        </b-col> 
                                    </b-row>
                                </b-card-text>
                            </b-card>
                        </div>
                       </b-col>
                    </b-row>
                    <hr> 
                    <br>
                    <h6 v-if=" vermas < arrayGerente2.length" style="cursor: pointer;" @click="getcampanas(vermas + 10)"><u>Ver más <b-spinner v-if="loader" small></b-spinner></u></h6>
                    <br>
                    <span v-if="vermas > 10 && !buscar_gerente" @click="subirArriba()" class="mdi mdi-arrow-up-thick " style="color:#fff; cursor: pointer;"> Regresar al Inicio</span> 
                 </div>     


            </template>
            <template v-if="tab == 3"> 
                 <div class="table-responsive"  id="global">
                      <b-row class="justify-content-center mt-2">
                         <b-col cols="11" md="6" class="mt-2"> 
                            <div v-for="(ran, index) in ejecutivo" :key="ran.id">
                            <b-card border-variant="light" text-variant="white" class="text-center mt-5 shadow"  header-tag="header" >
                                <template #header>
                                    <h4 class="mb-0"  style="font-size:18px;"> {{ran.ejecutivo}}   </h4>
                                </template>
                                <b-card-text>
                                    <b-row class="justify-content-center" style="margin-top:-90px;">
                                        <b-col cols="10"  style="margin-top:-5px;"> 
                                                <br > <br > <br><br v-if="isMobile">  
                                            <template v-if="!buscador_ejecutivo">
                                            <img v-if="index < 10" :src="'plato/'+ index + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h5 v-if="index > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                    <b>{{index + 1  }}</b>
                                                </h5>  
                                            </template>
                                            <template v-else>
                                                <img v-if="ran.lugar < 10" :src="'plato/'+ (ran.lugar - 1)  + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h4 v-if="ran.lugar > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                <b> {{ran.lugar}}</b>
                                                </h4> 
                                            </template>
                                            <br > 
                                            <h1 style="color: #0c273a;"><b>Puntos: {{ran.total}}</b></h1>
                                        </b-col>
                                    </b-row>
                                    <b-row class="justify-content-center" style="margin-top:20px;"> 
                                        <b-col cols="11">
                                            <b  style="color: #0c273a; font-size:20px;">Cumplimientos</b>
                                            <b-row  class="justify-content-center mt-2">
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Marzo</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;" class="mt-2" >
                                                            {{ran.marzo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Abril</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.abril}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Mayo</b></span>  
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.mayo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;  margin-left: -10px;"><b>Junio</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.junio}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                            </b-row>
                                        </b-col> 
                                    </b-row>
                                </b-card-text>
                            </b-card>
                            </div> 
                         </b-col>
                      </b-row>
                 </div> 
            </template>
            <template v-if="tab == 2 && user.perfil == 'Coordinador' "> 
                 <div class="table-responsive"  id="global">
                  <b-row class="justify-content-center mt-2">
                     <b-col cols="11" md="6" class="mt-2"> 
                        <div v-for="(ran, index) in coordinador" :key="ran.id">
                            <b-card border-variant="light" text-variant="white" class="text-center mt-5 shadow"  header-tag="header" >
                                <template #header>
                                    <h4 class="mb-0"  style="font-size:18px;">  {{ran.coordinador}}  </h4>
                                </template>
                                <b-card-text>
                                    <b-row class="justify-content-center" style="margin-top:-90px;">
                                        <b-col cols="10"  style="margin-top:-5px;"> 
                                            <br > <br > <br><br v-if="isMobile">  
                                            <template v-if="!buscar_coordinador">
                                            <img v-if="index < 10" :src="'plato/'+ index + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h5 v-if="index > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                    <b>{{index + 1  }}</b>
                                                </h5>  
                                            </template>
                                            <template v-else>
                                                <img v-if="ran.lugar < 10" :src="'plato/'+ (ran.lugar - 1)  + '.png'" class="rounded" alt="Image" style="width:25%; margin-top:-4px;">  
                                                <h4 v-if="ran.lugar > 9" style="color: #0c273a; margin-top:7px;  font-size:28px;" >
                                                <b> {{ran.lugar}}</b>
                                                </h4>  
                                            </template>
                                            <br > 
                                            <h1 style="color: #0c273a;"><b>Puntos: {{ran.total}}</b> </h1>
                                        </b-col>
                                    </b-row>
                                    <b-row class="justify-content-center" style="margin-top:20px;"> 
                                        <b-col cols="11">
                                            <b  style="color: #0c273a; font-size:20px;">Cumplimientos</b>
                                            <b-row  class="justify-content-center mt-2">
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Marzo</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;" class="mt-2" >
                                                            {{ran.marzo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Abril</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.abril}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;"><b>Mayo</b></span>  
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.mayo}} 
                                                        </h4> 
                                                    </center>
                                                </b-col>
                                                <b-col cols="3" >
                                                    <center>
                                                        <span style="text-transform:capitalize; font-size:16px;  color:#0b2739;  margin-left: -10px;"><b>Junio</b></span>
                                                        <h4 style="color: #0c273a; font-size:16px;"  class="mt-2">
                                                            {{ran.junio}} 
                                                        </h4> 
                                                    </center>
                                                </b-col> 
                                            </b-row>
                                        </b-col> 
                                    </b-row>
                                </b-card-text>
                            </b-card>
                        </div> 
                    </b-col>
                  </b-row>
                 </div> 
            </template>
            <br><br><br>
        </b-col>
     </b-row> 
</div>
</template>

<script>
function compare(a, b) {
  if (a.total > b.total) {
    return -1;
  }
  if (a.total < b.total) {
    return 1;
  }
  return 0;
}
import SpinnerLoader from "../../utils/SpinnerLoader.vue";
export default {
  name: 'PropioMovil',
 components:{
    SpinnerLoader
  },
  data(){
    return{
      isMobile: this.$mobile(),
      loader:false,
      arrayGerente:[],
      arrayGerente2:[],
      arrayEjecutivo:[],
      arrayCoordinador:[],
      tab:0,
      colors:'#83c32d',
      buscar_coordinador:"",
      buscar_gerente:"",
      buscador_ejecutivo:"",
      vermas:10,
      region_pdv:"Todas",
      arrarEjeCF:[],
      arrarEjeCM:[],
      arrarEjeN:[],
      arrarEjeO:[],
      arrarEjeS:[],
      arrarCooCF:[],
      arrarCooCM:[],
      arrarCooN:[],
      arrarCooO:[],
      arrarCooS:[],
      arrarGerCF:[],
      arrarGerCM:[],
      arrarGerN:[],
      arrarGerO:[],
      arrarGerS:[],
      array1:[],
      array2:[],
      array3:[]
    }
  },
  computed: {
    user() {
      return this.$store.getters.getInfoUser;
    },
    coordinador(){
     if (this.buscar_coordinador == '') {          
            return this.array2;
        }else{
               return   this.array2.filter(item => {
                    return   item.coordinador?.toLowerCase().includes(this.buscar_coordinador.toLowerCase()) ||
                             item.region?.toLowerCase().includes(this.buscar_coordinador.toLowerCase()) 
                    ;
              });
        }
    },
    gerente(){ 
            if (this.buscar_gerente == '') {          
                return this.array1;
            }else{
                return   this.array1.filter(item => {
                        return   item.idpdv?.toLowerCase().includes(this.buscar_gerente.toLowerCase()) ||
                                item.tienda?.toLowerCase().includes(this.buscar_gerente.toLowerCase()) 
                        ;
                });
            } 
    },
    ejecutivo(){
     if (this.buscador_ejecutivo == '') {          
            return this.array3;
        }else{
               return   this.array3.filter(item => {
                    return   item.ejecutivo?.toLowerCase().includes(this.buscador_ejecutivo.toLowerCase())
                    ;
              });
        }
    }
  },
  methods:{
    cambiaRegion(id){
         this.region_pdv = id;
         switch (this.region_pdv ) {
            case "Todas":
                this.array1 = this.arrayGerente;
                this.array2 = this.arrayCoordinador;
                this.array3 = this.arrayEjecutivo;
            break; 
            case "CENTRO FORANEO":
                 this.array1 = this.arrarEjeCF;
                 this.array2 = this.arrarCooCF;
                 this.array3 = this.arrarGerCF;
            break; 
            case "CENTRO METROPOLITANO":
                this.array1 = this.arrarEjeCM;
                this.array2 = this.arrarCooCM;
                this.array3 = this.arrarGerCM;
            break; 
            case "NORTE":
                this.array1 = this.arrarEjeN;
                this.array2 = this.arrarCooN;
                this.array3 = this.arrarGerN;
            break; 
            case "OCCIDENTE":
                this.array1 = this.arrarEjeO;
                this.array2 = this.arrarCooO;
                this.array3 = this.arrarGerO;
            break; 
            case "SUR":
                this.array1 = this.arrarEjeS;
                this.array2 = this.arrarCooS;
                this.array3 = this.arrarGerS;
            break; 
         }
    },
    cambiaTab(id){
        this.region_pdv = "Todas";
        this.tab = id; 
        this.buscar_gerente = ""; 
        this.buscar_coordinador = ""; 
    },
    subirArriba(){
      // this.$scrollTo("#subir");
       window.scrollTo(0, -500);
    },
    getcampanas(id){
      this.loader = true;
      this.vermas = id;
      this.buscar_gerente = '';
      this.buscar_coordinador = ''; 
      var url= 'ranking/propio?vermas='+ id;
        this.$api.get(url).then(
            ({data}) => {
                console.log(data);
                this.arrayGerente = data.gerente.sort(compare); 
                this.arrayGerente2 = data.gerente2.sort(compare); 
                this.arrarEjeCF = data.g_centrof.sort(compare); 
                this.arrarEjeCM = data.g_centrom.sort(compare); 
                this.arrarEjeN = data.g_norte.sort(compare); 
                this.arrarEjeO = data.g_occidente.sort(compare); 
                this.arrarEjeS = data.g_sur.sort(compare); 
                this.arrarCooCF = data.c_centrof.sort(compare); 
                this.arrarCooCM = data.c_centrom.sort(compare); 
                this.arrarCooN = data.c_norte.sort(compare); 
                this.arrarCooO = data.c_occidente.sort(compare); 
                this.arrarCooS = data.c_sur.sort(compare); 
                this.arrarGerCF = data.e_centrof.sort(compare); 
                this.arrarGerCM = data.e_centrom.sort(compare); 
                this.arrarGerN = data.e_norte.sort(compare); 
                this.arrarGerO = data.e_occidente.sort(compare); 
                this.arrarGerS = data.e_sur.sort(compare); 
                this.arrayCoordinador = data.coordinador.sort(compare);
                this.arrayEjecutivo = data.ejecutivo.sort(compare);
                this.cambiaRegion('Todas');
                this.loader = false;
            }
        );
    },
    regresarHome(){
        this.$bus.$emit("cambia_fondo2", true)
        this.$router.push("/"); 
    }
  },
  mounted(){
          if (this.isMobile)
      {
        this.$bus.$emit("cambi_fo9", true)
        //  window.scrollTo(0, -200);     
      } 
    this.$bus.$emit("cambia_fondo", true)
    this.getcampanas(this.vermas);
  }
}
</script>
<style>
@media only screen and (min-width: 1000px) 
{
 
}
@media only screen and (min-width: 1300px) 
{
 
}
@media only screen and (min-width: 1400px)
{
 
}
@media only screen and (min-width: 1600px)
{
 
}
@media only screen and  (min-width: 1800px)
{
 
}

.table {
--bs-table-bg: #fff0; 
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #0c273a;
    background-color: #33d951;
    border-color: #33d951;
}

.nav-tabs .nav-link { 
    background: #686c6f;
    border: 5px   solid #019df4;
    border-top-left-radius: 0.8rem;
    color: #fff;
    border-top-right-radius: 0.8rem; 
}

#outer_wrapper {  
    overflow: scroll;  
    width:100%;
}
#outer_wrapper #inner_wrapper {
    width:1000px; /* If you have more elements, increase the width accordingly */
}
#outer_wrapper #inner_wrapper div.box { /* Define the properties of inner block */
    width: 250px;
    height:300px;
    float: left;
    margin: 0 4px 0 0;
    border:1px grey solid;
}

.card-header { 
   background-color: #0c273a;   
   border-radius: 3rem;
}

.card-body {
 background: #fff;
 border-radius: 3rem;
}

.card{
 border-radius: 3rem;
--bs-border-radius: 3rem;
}

#global {
	height: 1000px;
	width: 100%;
	border: 1px solid #dddddd00;
	background: #f1f1f100;
	overflow-y: scroll;
}
</style>